import { useStyle } from '@/classify';
import { Option as InformedOption, Select as InformedSelect, useFieldState } from 'informed';
import { Fragment } from 'react';
import { ChevronDown as ChevronDownIcon } from 'react-feather';
import { FieldIcons, Message } from '../Field';
import Icon from '../Icon';
import defaultClasses from './select.module.css';

const arrow = (
  <Icon
    src={ChevronDownIcon}
    size={24}
  />
);

const Select = props => {
  const { before, classes: propClasses, field, items, message, showInternalErrorMsg = true, ...rest } = props;
  const fieldState = useFieldState(field);
  const classes = useStyle(defaultClasses, propClasses);
  const inputClass = fieldState.error ? classes.input_error : classes.input;

  const options = items.map(({ disabled = null, hidden = null, label, value, key = value }) => (
    <InformedOption
      key={key}
      disabled={disabled}
      hidden={hidden}
      value={value}
    >
      {label || (value != null ? value : '')}
    </InformedOption>
  ));

  return (
    <Fragment>
      <FieldIcons
        after={arrow}
        before={before}
      >
        <InformedSelect
          {...rest}
          className={inputClass}
          field={field}
        >
          {options}
        </InformedSelect>
      </FieldIcons>
      {showInternalErrorMsg ? <Message fieldState={fieldState}>{message}</Message> : null}
    </Fragment>
  );
};

export default Select;
